import { APIS_BASE_URL } from '../../../../constants/env';

export const getOrderInvoiceDownloadUrl = (parcelNumber, format) =>
  `${APIS_BASE_URL}/orders/order-invoice?parcelNumber=${parcelNumber}&fileFormat=${format}`;
